import React from 'react'

import { IconProps } from '../Types'

export const ErrorPhoto = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="ErrorPhoto"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path d="m5.61,7.66c0,1.64,1.32,2.97,2.96,2.97s2.96-1.33,2.96-2.97-1.32-2.97-2.96-2.97-2.96,1.33-2.96,2.97Zm4.22,0c0,.7-.57,1.27-1.26,1.27s-1.26-.57-1.26-1.27.57-1.27,1.26-1.27,1.26.57,1.26,1.27Z"/><path d="m6.78,21.24c-.22-.36-.34-.77-.38-1.19h-2.03c-.23,0-.42-.19-.42-.42v-5.91c.36-.04.73-.06,1.08-.06h.02c1.47-.03,2.92.3,4.22.94l.87-1.74c-1.58-.78-3.33-1.18-5.12-1.14-.36,0-.73.02-1.08.05v-7.41c0-.23.19-.42.42-.42h15.2c.23,0,.42.19.42.42v7.92c0,1.35,1.93,1.4,1.93.03v-7.95c0-1.3-1.05-2.36-2.35-2.36H4.36c-1.29,0-2.35,1.06-2.35,2.36v8.36c-.02.11-.02.22,0,.33v6.59c0,1.3,1.05,2.36,2.35,2.36h3.13c-.29-.21-.54-.45-.73-.76h0Z"/><path d="M15.44 17.52c-.12-.06-.24-.11-.39-.11-.07 0-.14.01-.2.03-.06.02-.13.05-.19.08-.27.14-.45.41-.45.73 0 .46.38.84.84.84.2 0 .38-.08.52-.2.19-.15.32-.38.32-.64 0-.32-.19-.59-.45-.73ZM15.06 16.91c.14 0 .26-.05.36-.12.18-.12.31-.32.31-.55v-3.08c0-.37-.3-.67-.67-.67s-.67.3-.67.67v3.08c0 .23.13.43.31.55.11.07.23.12.36.12Z"/><path d="m21.89,19.51l-.18-.39-5.01-10.07c-.15-.3-.39-.56-.68-.73-.29-.17-.62-.27-.97-.27s-.68.09-.97.27c-.29.18-.53.43-.68.74l-5.1,10.24c-.14.28-.21.6-.2.91.02.34.12.64.27.89.16.27.4.49.67.65.17.1.38.16.64.2h.09c.06.03.12.04.18.04h10.2c.32,0,.63-.08.9-.24.28-.16.51-.38.67-.65.17-.27.26-.58.27-.89,0-.24-.03-.49-.11-.72v.02Zm-1.91.53c-.05.07-.13.12-.21.12h-9.41c-.09,0-.17-.04-.21-.12-.05-.07-.05-.17,0-.24l1.57-3.16.91-1.81,2.23-4.49c.04-.08.13-.14.22-.14s.18.05.22.14l3.12,6.26,1.59,3.21c.04.08.03.17,0,.24h0Z"/>',
    }}
  />
)

ErrorPhoto.displayName = 'ErrorPhoto'

export const tags = ['ErrorPhoto', '']
